import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../i18n/translations';

const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('udaan_lang') || 'en');

  useEffect(() => {
    localStorage.setItem('udaan_lang', lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }, [lang]);

  const t = (key) => {
    const parts = key.split('.');
    let val = translations[lang];
    for (const p of parts) {
      if (val && typeof val === 'object') val = val[p];
      else break;
    }
    if (val === undefined) {
      // fallback to english
      let fb = translations.en;
      for (const p of parts) fb = fb?.[p];
      return fb || key;
    }
    return val;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t, isRTL: lang === 'ar' }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
};
